export const frontendAccessRules = {
    '/admin/users': ['siteadmin'],
    '/admin/dashboard': ['siteadmin', 'admin'],
    '/admin/messages': ['siteadmin', 'admin'],
    '/admin/products': ['siteadmin', 'admin'],
    '/admin/tags-categories': ['siteadmin', 'admin'],
    '/admin/orders': ['siteadmin', 'admin'],
    '/admin/analytics': ['siteadmin', 'admin'],
    '/admin/contacts': ['siteadmin', 'admin']
};